import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import { Divider } from "@material-ui/core";
import { clsx } from "clsx";
import Typography from "@material-ui/core/Typography";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useRouteMatch } from "react-router-dom";
import { useHistory } from "../../hooks/useHistory";

import { TabPanel, a11yProps } from "../tabPanel";
import { tabsStyles } from "./tabs-layout.styles";

interface Component {
  value?: string;
  slug: string;
  label: string | JSX.Element;
  component: JSX.Element;
  id?: string;
}

interface TabsLayoutProps {
  isRedirected?: boolean;
  title?: string;
  listComponents: Component[];
  additionalActionsComponent?: React.ReactNode | JSX.Element;
  variant?: "default" | "new";
}

export const TabsLayout = ({
  title,
  listComponents,
  additionalActionsComponent,
  isRedirected = true,
  variant = "default",
}: TabsLayoutProps) => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const styles = tabsStyles();
  const containerRoutes = listComponents.map((component) => component.slug);
  const indexRoute = containerRoutes.indexOf(url);
  const [value, setValue] = useState(indexRoute >= 0 ? indexRoute : 0);

  const isMyEvents = title === "My Events";

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (isRedirected) {
      history.push(containerRoutes[newValue]);
    }
  };

  return (
    <>
      {title !== "" && (
        <Grid item xs={12}>
          <Typography
            variant="h2"
            color="textPrimary"
            component="h1"
            className={styles.titleModule}
          >
            {isMyEvents ? "Events" : title}
          </Typography>
        </Grid>
      )}
      <Grid container justifyContent="space-between" alignItems="center">
        <Tabs
          id="learningTabs"
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="full width tabs example"
          className={clsx(styles.newParticipantTabs, {
            [styles.newTab]: variant === "new",
          })}
        >
          {listComponents.map(({ label, slug, id }, index) => (
            <Tab key={slug} label={label} {...a11yProps(index, id)} />
          ))}
        </Tabs>
        {additionalActionsComponent}
      </Grid>
      {variant === "default" && (
        <Grid item lg={12}>
          <Divider className={styles.divider} />
        </Grid>
      )}

      {listComponents.map(({ component, slug }, index) => (
        <TabPanel key={slug} value={value} index={index}>
          {component}
        </TabPanel>
      ))}
    </>
  );
};
